import { format } from 'date-fns';
import { AresResult } from '../api/gql';

export const getAddressFromAresResult = (aresRes: AresResult) => {
  return [aresRes.streetAddress, aresRes.zip, aresRes.city, aresRes.country].filter((e) => e).join('\n');
};

/**
 * Converts number from centesimal representation. E.g. ¢123 -> $1.23
 */
export function fromCentesimal(value: null): null;
export function fromCentesimal(value: number | string): number;
export function fromCentesimal(value: number | string | null): number | null {
  if (value === null) {
    return null;
  }
  if (typeof value === 'string') {
    value = parseInt(value);
  }
  return value / 100;
}

/**
 * Converts number to centesimal representation. E.g. $1.23 -> ¢123
 */
export function toCentesimal(value: null): null;
export function toCentesimal(value: number | string): number;
export function toCentesimal(value: number | string | null): number | null {
  if (value === null) {
    return null;
  }
  if (typeof value === 'string') {
    value = parseFloat(value);
  }
  return Math.round(value * 100);
}

export function toDateString(value: string | null | undefined): string | null {
  if (!value) {
    return null;
  }
  return format(new Date(value), 'yyyy-MM-dd');
}
